import React, { FC, useEffect, useRef } from "react";

import { Button, ButtonVariant, Theme } from "@in/component-library";
import { useLayout } from "../../hooks/use-layout";

interface AddProfileSucceededProps {
  onClose: () => void;
  email: string;
  phoneNumber: string;
  countryCode: string;
  accountName: string;
  orgName: string;
  isPersonal: boolean;
}

const AddProfileSucceeded: FC<AddProfileSucceededProps> = ({
  onClose,
  email,
  phoneNumber,
  countryCode,
  accountName,
  orgName,
  isPersonal
}) => {
  const { translations } = useLayout();

  const btnRef = useRef<HTMLButtonElement>(undefined);

  useEffect(() => {
    btnRef.current?.focus();
  }, []);

  return (
    <>
      {isPersonal ? (
        <p
          className="add-profile-succeeded__confirmation"
          dangerouslySetInnerHTML={{
            __html: translations.verifyEmailNewPersonalProfileVerified.replace(
              "{name}",
              `<span class="data-hj-suppress add-profile-succeeded__confirmation--strong">${accountName}</span>`
            )
          }}
        />
      ) : (
        <p
          className="add-profile-succeeded__confirmation"
          dangerouslySetInnerHTML={{
            __html: translations.verifyEmailNewProfileVerifiedText
              .replace(
                "{name}",
                `<span class="data-hj-suppress add-profile-succeeded__confirmation--strong">${accountName}</span>`
              )
              .replace(
                "{org}",
                `<span class="data-hj-suppress add-profile-succeeded__confirmation--strong">${orgName}</span>`
              )
          }}
        />
      )}

      <div className="add-profile-succeeded__contact-info-wrapper">
        <div className="add-profile-succeeded__contact-info-field">
          <p className="add-profile-succeeded__label">{translations.verifyEmailEmailLabel}</p>
          <p className="data-hj-suppress">{email}</p>
        </div>

        <div className="add-profile-succeeded__contact-info-field">
          <p className="add-profile-succeeded__label">{translations.verifyEmailPhoneNumberLabel}</p>
          <p className="data-hj-suppress">
            {countryCode} {phoneNumber}
          </p>
        </div>
      </div>
      <div aria-live="polite" className="add-profile-succeeded__button">
        <Button type="submit" variant={ButtonVariant.Solid} theme={Theme.Neutral} onClick={onClose} innerRef={btnRef}>
          {translations.verifyEmailCloseModal}
        </Button>
      </div>
    </>
  );
};

export default AddProfileSucceeded;
